import React from 'react';
import { Routes, Route } from 'react-router-dom';
import VideoPage from './components/VideoPage';

function App() {
  return (
    <Routes>
      <Route path="/:id/" element={<VideoPage />} />
    </Routes>
  );
}

export default App;
